import { IBaryError } from './bary-error';

export interface IBaryProblem {
  detail: string | undefined;
  message: string | undefined;
  type: string | undefined;
  status: string | undefined;
  errorCode: string | undefined;
  baryErrors: Array<IBaryError>;
}

export class BaryProblem implements IBaryProblem {
  detail: string | undefined;
  message: string | undefined;
  type: string | undefined;
  status: string | undefined;
  errorCode: string | undefined;
  baryErrors: Array<IBaryError> = [];
}
